import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { safeClearInterval, safeSetInterval } from "./SafeTiming";
import { TimingCallback } from "./Timeout"
export  interface IInterval
{
    Name(): string;

    Start(): void;
    Restart(): void;
    Stop(): void;

    /**
     * @return interval in milliseconds
     */
    // Interval(): number;

    Running(): boolean;
}

export interface IChangeableInterval extends IInterval
{
    ChangeInterval(intervalMillis: number): void;
}


export class Interval implements IChangeableInterval
{
    protected resid: ResourceIdentifier;

    protected running: boolean = false;
    protected intervalid: number = 0;

    protected callback: TimingCallback = null;
    protected interval: number = 0;

    public constructor(resid: ResourceIdentifier, callback: TimingCallback, intervalMillis: number)
    {
        this.resid = resid;

        if (callback == null) throw "callback must not be null";
        this.callback = callback;

        if (intervalMillis < 0) throw "intervalMillis must not be negative";
        this.interval = intervalMillis;
    }

    // public Interval(): number
    // {
    //     return this.interval;
    // }

    protected IntervalTriggered(): void
    {
        this.callback();
    }

    public ChangeInterval(intervalMillis: number): void
    {
        if (intervalMillis < 0) throw "intervalMillis must not be negative";
        this.interval = intervalMillis;
    }

    public Start(): void
    {
        if (this.running)
        {
            this.Stop();
        }

        this.running = true;
        this.intervalid = safeSetInterval(() => this.IntervalTriggered(), this.interval);
    }

    public Restart(): void
    {
        this.Start();
    }

    public Stop(): void
    {
        if (this.running)
        {
            this.running = false;
            safeClearInterval(this.intervalid);
        }
    }

    public Running(): boolean
    {
        return this.running;
    }

    public Name(): string
    {
        return this.resid.ID()
    }
}